import { convertTimeToMinutes } from 'utils';

export const JORNADA_VALIDADO_PENDING = 'AGUARDANDO_APROVACAO';
export const JORNADA_SEM_HORA_EXTRA = 'SEM_HORA_EXTRA';
export const JORNADA_HORA_EXTRA = 'HORA_EXTRA';
export const JORNADA_SEM_HORA_EXTRA_LABEL = 'Sem Hora Extra';

export const getAutorizadorId = (autorizador) => {
  if (!autorizador) return null;
  if (typeof autorizador === 'object') return autorizador.id || null;
  return autorizador;
};

export const normalizeJornadaValidadoStatus = (validado) => {
  if (validado === 'VALIDADO' || validado === 'INVALIDADO') return validado;
  return JORNADA_VALIDADO_PENDING;
};

export const getJornadaValidadoDisplay = (validado, hasHoraExtra = true) => {
  if (!hasHoraExtra) {
    return { value: 'VALIDADO', label: 'Válido' };
  }
  const status = normalizeJornadaValidadoStatus(validado);
  if (status === 'VALIDADO') {
    return { value: 'VALIDADO', label: 'Válido' };
  }
  if (status === 'INVALIDADO') {
    return { value: 'INVALIDADO', label: 'Inválido' };
  }
  return { value: JORNADA_VALIDADO_PENDING, label: 'Aguardando aprovação' };
};

export const getJornadaHoraExtraDisplay = (row) => {
  if (row?.horaExtraAutorizadoPorNome) {
    return {
      value: JORNADA_HORA_EXTRA,
      label: 'Hora Extra',
      autorizadoPorNome: row.horaExtraAutorizadoPorNome,
    };
  }
  return {
    value: JORNADA_SEM_HORA_EXTRA,
    label: JORNADA_SEM_HORA_EXTRA_LABEL,
    autorizadoPorNome: null,
  };
};

export const formHasHoraExtra = (values, horaExtraDisabled) => Boolean(
  !horaExtraDisabled
  || values?.horaExtraAutorizadoPor
  || values?.horaExtraJustificativa,
);

export const jornadaRequiresHoraExtra = (data, jornadaTotal) => {
  if (!data || !jornadaTotal) return false;
  const jornadaTotalMinutes = convertTimeToMinutes(jornadaTotal);
  if (!jornadaTotalMinutes) return false;
  const ts = typeof data === 'string' ? parseInt(data, 10) : data;
  const day = new Date(ts).getDay();
  if (day === 0) return true;
  if (day === 6) return jornadaTotalMinutes > 4 * 60;
  return jornadaTotalMinutes > 8 * 60;
};

export const rowHasHoraExtra = (row) => Boolean(
  row?.horaExtraAutorizadoPor
  || row?.horaExtraAutorizadoPorNome
  || row?.horaExtraJustificativa
  || jornadaRequiresHoraExtra(row?.data, row?.jornadaTotal),
);

export const canValidateJornada = (values, authId, adminPermission) => {
  if (!values?.id || !authId) return false;
  if (adminPermission) return true;
  return getAutorizadorId(values.horaExtraAutorizadoPor) === authId;
};

const TRANSITION_MATRIX = {
  [JORNADA_VALIDADO_PENDING]: ['VALIDADO', 'INVALIDADO'],
  VALIDADO: ['INVALIDADO'],
  INVALIDADO: ['VALIDADO'],
};

export const canTransitionJornadaValidado = (fromValidado, toValidado) => {
  if (!toValidado) return false;
  const from = normalizeJornadaValidadoStatus(fromValidado);
  if (from === toValidado) return false;
  const allowed = TRANSITION_MATRIX[from];
  return Array.isArray(allowed) && allowed.includes(toValidado);
};
